var render = function render(_c,_vm){return _c('div',{staticClass:"wrapper"},[_c('div',[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('common.errors.404'),expression:"'common.errors.404'"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }